import type { ReactNode, CSSProperties } from 'react';
import { cardStyle, cardStyleLg, labelStyle, valueStyle } from './styles';

interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
  size?: 'md' | 'lg';
  onClick?: () => void;
}

export function Card({ children, style, size = 'md', onClick }: CardProps) {
  const base = size === 'lg' ? cardStyleLg : cardStyle;
  return (
    <div
      onClick={onClick}
      style={{ ...base, ...style, cursor: onClick ? 'pointer' : undefined }}
    >
      {children}
    </div>
  );
}

export function CardLabel({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return <div style={{ ...labelStyle, ...style }}>{children}</div>;
}

export function CardValue({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return <div style={{ ...valueStyle, ...style }}>{children}</div>;
}

export function CardDescription({ children }: { children: ReactNode }) {
  return <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '4px' }}>{children}</div>;
}
